module.exports = __webpack_public_path__ + "media/music/1c9630b745711a0b829841e8555d76e4.mp3";